import messages from "messages";
import { ComponentPropsWithoutRef } from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import styles from "./SessionTypeLengthEditor.module.scss";
import getClasses from "utils/getClasses";

const MIN_LENGTH = 5;

const PLACEHOLDER = "20";

type Props = {
  value: SessionType["length_min"] | undefined;
  onChange: ComponentPropsWithoutRef<typeof FormControl>["onChange"];
  isInvalid: boolean | undefined;
  onFocus: () => void;
};

const SessionTypeLengthEditor = ({
  value,
  onChange,
  isInvalid,
  onFocus,
}: Props) => (
  <InputGroup
    hasValidation
    className={getClasses(
      styles["session-type-length-editor"],
      isInvalid && styles["session-type-length-editor--invalid"],
    )}
  >
    <FormControl
      isInvalid={isInvalid}
      className={styles["session-type-length-editor__input"]}
      type="number"
      min={MIN_LENGTH}
      defaultValue={value}
      onChange={onChange}
      placeholder={PLACEHOLDER}
      name={"length_min"}
      onFocus={onFocus}
    />
    <InputGroup.Text className={styles["session-type-length-editor__unit"]}>
      {messages.minutesShort}
    </InputGroup.Text>
    {isInvalid && (
      <FormControl.Feedback
        className={styles["session-type-length-editor__feedback"]}
        type="invalid"
      >
        {`Length has to be more than ${MIN_LENGTH} mins`}
      </FormControl.Feedback>
    )}
  </InputGroup>
);

export default SessionTypeLengthEditor;
